export default {
      id: "gb-nir-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#gb-nir",
      toString: function () {
        return this.url;
      }
    }